import { useQuery, useMutation } from "react-query";
import {
	getAllGifts_api,
	getAllGiftStatus_api,
	getAllPaymentStatus_api,
	getAllGiftsDetails_api,
	downloadGifts_api,
} from "../services/gifts";

export const useGetAllGifts = (params) =>
	useQuery(["getAllGifts", params], () => getAllGifts_api(params));

export const useGetAllGiftStatus = () =>
	useQuery(["getAllGiftStatus"], () => getAllGiftStatus_api());

export const useGetAllPaymentStatus = () =>
	useQuery(["getAllPaymentStatus"], () => getAllPaymentStatus_api());

export const useGetGiftsDetails = (params) =>
	useQuery(["getGiftsDetails", params], () => getAllGiftsDetails_api(params));

export const useDownloadGifts = () =>
	useMutation("downloadGifts", (payload) => downloadGifts_api(payload));
